
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5407',
  depVersions: {
  "data-privacy-request-ui": "static-1.5407",
  "data-fetching-client": "static-1.9559",
  "head-dlb": "static-1.4884",
  "history": "static-4.47",
  "hs-test-utils": "static-1.7895",
  "hub-http-shared-msw-handlers": "static-1.9688",
  "hubspot-dlb": "static-2.1828",
  "HubStyleTokens": "static-2.11330",
  "I18n": "static-7.1598",
  "jasmine-runner": "static-1.6353",
  "privacy-center-public-service-types": "static-1.4670",
  "quartz": "static-1.6845",
  "react-dlb": "static-1.75",
  "react-router-dom": "static-5.26",
  "ui-components-test-utils": "static-1.5468",
  "UIComponents": "static-3.8277",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.83",
  "foundations-assets": "static-1.4727",
  "foundations-components": "static-1.7686",
  "foundations-components-test-utils": "static-1.5169",
  "foundations-theming": "static-1.4295",
  "hub-http": "static-1.6103",
  "quartz-config": "static-1.623",
  "quartz-core": "static-1.6064",
  "quick-fetch": "static-1.3817",
  "raven": "static-3.5768",
  "react": "static-7.183",
  "react-rhumb": "static-1.16538",
  "SharedI18nStrings": "static-1.181",
  "ui-addon-i18n": "static-1.11030",
  "usage-tracker": "static-1.7219",
  "usage-tracker-anonymous": "static-1.5636",
  "usage-tracker-core": "static-1.7069",
  "enviro": "static-4.416",
  "hs-promise-rejection-tracking": "static-1.5433",
  "PortalIdParser": "static-2.377",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4034",
  "immutable": "static-2.76",
  "metrics-js": "static-1.9522",
  "react-redux": "static-7.69",
  "redux": "static-4.16",
  "styled-components": "static-2.87",
  "bend-plugin-trellis-migration": "static-1.3310",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3122",
  "quartz-webpack": "static-1.3069",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.79",
  "HeadJS": "static-2.732",
  "framer-motion": "static-1.69",
  "hs-test-utils-bend-plugin": "static-1.3006",
  "msw": "static-1.39",
  "testing-library": "static-1.149",
  "ts-schema": "static-1.3982",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.80",
  "react-utils": "static-2.5251",
  "StyleGuideUI": "static-3.485",
  "jasmine": "static-4.4208",
  "rpc-client-utils": "static-1.4526",
  "HubStyle": "static-2.11638",
  "ui-addon-draggable": "static-3.4652",
  "cssUtils": "static-1.764",
  "hs-story-utils": "static-1.9312",
  "icons": "static-2.637",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.96",
  "ui-images": "static-2.1124",
  "bend-plugin-foundations-components": "static-1.3955",
  "floating-ui": "static-1.53",
  "foundations-theming-specialty": "static-1.2011",
  "react-aria": "static-1.63",
  "tanstack-table": "static-1.52",
  "trellis-assets": "static-1.1474",
  "ui-fonts": "static-1.592",
  "foundations-components-legacy": "static-1.711",
  "bend-plugin-foundations-theming": "static-1.2778",
  "foundations-theming-base": "static-1.3280",
  "stylex": "static-1.29",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.816",
  "hubspotter-http": "static-1.4555",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.20",
  "quartz-auth": "static-1.520",
  "quartz-head": "static-1.510",
  "quartz-i18n": "static-1.520",
  "quartz-routing": "static-1.275",
  "quartz-test": "static-1.520",
  "quartz-tracking": "static-1.224",
  "usage-tracker-container": "static-1.7209",
  "csstype": "static-1.50",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3041",
  "chirp-fetch": "static-1.1765",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.67",
  "sassPrefix": "static-1.153",
  "hubspotter-http-shared-msw-handlers": "static-1.9686",
  "usage-tracker-session-replay": "static-1.4905",
  "amplitude-session-replay-browser": "static-1.57"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5407",
  "data-fetching-client": "/data-fetching-client/static-1.9559",
  "head-dlb": "/head-dlb/static-1.4884",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.7895",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9688",
  "hubspot-dlb": "/hubspot-dlb/static-2.1828",
  "HubStyleTokens": "/HubStyleTokens/static-2.11330",
  "I18n": "/I18n/static-7.1598",
  "jasmine-runner": "/jasmine-runner/static-1.6353",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4670",
  "quartz": "/quartz/static-1.6845",
  "react-dlb": "/react-dlb/static-1.75",
  "react-router-dom": "/react-router-dom/static-5.26",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5468",
  "UIComponents": "/UIComponents/static-3.8277",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.83",
  "foundations-assets": "/foundations-assets/static-1.4727",
  "foundations-components": "/foundations-components/static-1.7686",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5169",
  "foundations-theming": "/foundations-theming/static-1.4295",
  "hub-http": "/hub-http/static-1.6103",
  "quartz-config": "/quartz-config/static-1.623",
  "quartz-core": "/quartz-core/static-1.6064",
  "quick-fetch": "/quick-fetch/static-1.3817",
  "raven": "/raven/static-3.5768",
  "react": "/react/static-7.183",
  "react-rhumb": "/react-rhumb/static-1.16538",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11030",
  "usage-tracker": "/usage-tracker/static-1.7219",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5636",
  "usage-tracker-core": "/usage-tracker-core/static-1.7069",
  "enviro": "/enviro/static-4.416",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4034",
  "immutable": "/immutable/static-2.76",
  "metrics-js": "/metrics-js/static-1.9522",
  "react-redux": "/react-redux/static-7.69",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.87",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3310",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3122",
  "quartz-webpack": "/quartz-webpack/static-1.3069",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.79",
  "HeadJS": "/HeadJS/static-2.732",
  "framer-motion": "/framer-motion/static-1.69",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3006",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.149",
  "ts-schema": "/ts-schema/static-1.3982",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.80",
  "react-utils": "/react-utils/static-2.5251",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "jasmine": "/jasmine/static-4.4208",
  "rpc-client-utils": "/rpc-client-utils/static-1.4526",
  "HubStyle": "/HubStyle/static-2.11638",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4652",
  "cssUtils": "/cssUtils/static-1.764",
  "hs-story-utils": "/hs-story-utils/static-1.9312",
  "icons": "/icons/static-2.637",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.96",
  "ui-images": "/ui-images/static-2.1124",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3955",
  "floating-ui": "/floating-ui/static-1.53",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2011",
  "react-aria": "/react-aria/static-1.63",
  "tanstack-table": "/tanstack-table/static-1.52",
  "trellis-assets": "/trellis-assets/static-1.1474",
  "ui-fonts": "/ui-fonts/static-1.592",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.711",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2778",
  "foundations-theming-base": "/foundations-theming-base/static-1.3280",
  "stylex": "/stylex/static-1.29",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "hubspotter-http": "/hubspotter-http/static-1.4555",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.20",
  "quartz-auth": "/quartz-auth/static-1.520",
  "quartz-head": "/quartz-head/static-1.510",
  "quartz-i18n": "/quartz-i18n/static-1.520",
  "quartz-routing": "/quartz-routing/static-1.275",
  "quartz-test": "/quartz-test/static-1.520",
  "quartz-tracking": "/quartz-tracking/static-1.224",
  "usage-tracker-container": "/usage-tracker-container/static-1.7209",
  "csstype": "/csstype/static-1.50",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3041",
  "chirp-fetch": "/chirp-fetch/static-1.1765",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.67",
  "sassPrefix": "/sassPrefix/static-1.153",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9686",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4905",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.57"
}
};
